<div
  v-if="shouldRenderConfig"
  v-bind:class="getClassName + 'Container'"
>
  <a v-if="getPPFactsheet" :href="getPPFactsheet" target="_blank">
    <button type="button" :class="getClassName" class="btn btn-primary">
      <img :class="getClassName + 'Icon'" :src="this.getBaseUrl + '/images/matrix/download.png'"/>
      <span>{{ $t('Download Template') }}</span>
    </button>
  </a>
</div>
